import { useState, useEffect } from 'react';
import type { Carrier } from '../api/types';
import { fetchCarriers } from '../api/client';

export function useCarriers() {
  const [carriers, setCarriers] = useState<Carrier[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCarriers()
      .then(setCarriers)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return { carriers, loading };
}
